import { Select } from 'antd';
import * as React from 'react';

export enum BaselineStatusFilterValue {
    ALL = 'all',
    HIGH_COVERAGE = 'high_coverage',
    LOW_COVERAGE = 'low_coverage',
    EMPTY_BASELINES = 'empty_baselines'
}

type Props = {
    value: BaselineStatusFilterValue;
    onChange: (value: BaselineStatusFilterValue) => void;
};

const BaselineStatusFilter: React.FC<Props> = ({ value, onChange }) => {
    const options = [
        { value: BaselineStatusFilterValue.ALL, label: 'All' },
        { value: BaselineStatusFilterValue.HIGH_COVERAGE, label: 'High coverage (>= 80%)' },
        { value: BaselineStatusFilterValue.LOW_COVERAGE, label: 'Low coverage (< 80%)' },
        { value: BaselineStatusFilterValue.EMPTY_BASELINES, label: 'Empty baselines' }
    ];

    return (
        <Select
            data-id="test-projects-baseline-status-filter"
            value={value}
            onChange={onChange}
            options={options}
            style={{ width: 220 }}
            placeholder="Baseline status"
        />
    );
};

export default BaselineStatusFilter;
